import React, { useState, useEffect } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'

import facebook from "../../common/media/facebook-dark.svg";
import instagram from "../../common/media/instagram-dark.svg";
import twitter from "../../common/media/twitter-dark.svg";

import logo_dark from "../../common/media/cc-logo-grey.svg";
import logo from "../../common/media/cc_logo_white.svg";
import "react-responsive-carousel/lib/styles/carousel.min.css";


import { getMerchantCodeWithPrefix } from '../../../tools/MyCCMerchantLinkGenerator';
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';

const logo_merchant = "https://res.cloudinary.com/carbonclick/image/upload/v1662539423/Enterprise/Kathryn%20Wilson/Logo_cxdyzi.png"; // use here or from cloudinary
const kind_1 = 'https://res.cloudinary.com/carbonclick/image/upload/v1662539423/Enterprise/Kathryn%20Wilson/kind-1_fv7pgb.png';
const kind_2 = 'https://res.cloudinary.com/carbonclick/image/upload/v1662539424/Enterprise/Kathryn%20Wilson/kind-2_byut5r.png';
const kind_3 = 'https://res.cloudinary.com/carbonclick/image/upload/v1662539424/Enterprise/Kathryn%20Wilson/kind-3_kp9n5n.png';
const kw_profile = 'https://res.cloudinary.com/carbonclick/image/upload/v1662539424/Enterprise/Kathryn%20Wilson/KW_Profile_uqf1ea.png';

const LandingPage = ({ merchantCode, fetchedImpact }) => {

    useEffect(() => {
        //getProjects("NZ").then(response => response.json()).then(data => setProjects(data));

    }, []);

    return (
        <div>
            <div className="center p-3">
                <img src={logo_merchant} style={{ height: '60px' }} />
            </div>
            <div className="h-85vh w-100 position-relative img-cover hero-img vertical-align-parent" >
                <div className="container color-white text-left vertical-align">
                    <div className="mobile-hide">
                        <div className="mw-720px">
                            <h1 className="mb-4 text-shadow mt-0">Footwear with a kinder footprint</h1>
                            <h3 className="mb-3 text-shadow">We love and appreciate the environment as much as we do making beautiful shoes, which is why we’re going Climate Friendly.</h3>
                        </div>

                        <div className="d-flex">
                            <p className="mr-2 mt-1 mb-0">Powered By</p>
                            <div>
                                <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 30 }} src={logo} /></a>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-show text-center">
                        <h2 className="mb-4 text-shadow mt-0">Footwear with a kinder footprint</h2>
                        <h4 className="mb-3 text-shadow">We love and appreciate the environment as much as we do making beautiful shoes, which is why we’re going Climate Friendly.</h4>
                    </div>
                </div>
            </div>
            <div className="mobile-show">
                <div className="bg-primary p-3 text-center">
                    <div className="d-flex w-fit center color-white">
                        <p className="mr-2 font-bold mt-1 mb-0">Powered By</p>
                        <div>
                            <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 30 }} src={logo} /></a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="content" className="py-6 bg-secondary">
                <div className="container text-center">
                    <div className="row mb-4">
                        <div className="col-6 d-grid mobile-hide">
                            <div className="img-cover ml-5 handbag-bg">
                                <img style={{top: "36px", left: "-48px"}} className="h-240px position-absolute shadow-lg" src={kind_1} />
                            </div>
                        </div>
                        <div className="col-6 d-grid text-left color-tertiary">
                            <div className="px-3 py-4">
                                <h2 className="font-bold">Introducing the KIND collection</h2>
                                <p>We love and appreciate the environment as much as we do making beautiful shoes, that is why our ‘KIND’ collection has been consciously crafted <b className="color-primary">using lower impact materials, such as Global Recycling Standard certified recycled leather and fly-knit uppers made from recycled plastic bottles.</b> The development of these three styles has been a two year project for us at Kathryn Wilson footwear and is the beginning of our sustainability journey, with hopefully a lot more styles to follow. Small steps made frequently can have an enormous impact over time and we believe it’s about ‘doing things better’ and ‘constantly improving’ our positive impact with a considered selection of manufacturing components and the methods used to produce our footwear designs.</p>
                                <a href="https://www.kathrynwilson.com/collections/kind/KIND" className="btn btn-primary">SHOP NOW</a>
                                
                                <div className="mobile-show pt-3">
                                    <img className="center mw-100" src={kind_2} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="py-5" style={{marginTop: "-6rem"}}>
                <div className="container text-center">
                    <div className="bg-primary px-3 py-5">
                        <div className="row text-center">
                            <div className="col-6 mb-3 mobile-border-0 color-white" style={{ borderRight: "4px solid" }}>
                                <h2 className="mt-3 color-white">Our new KIND range</h2>
                            </div>
                            <div className="col-6 mb-3">
                                <div className="row">
                                    <div className="col-6 mb-3">
                                        <h3 className="mt-3 color-white">$10 contributed</h3>
                                        <h5 className="color-white font-bold">With Every Pair</h5>
                                    </div>
                                    <div className="col-6 mb-3">
                                        <h3 className="mt-3 color-white">139,048 kg</h3>
                                        <h5 className="color-white font-bold">CO2 Offset</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pt-3">
                            <a href="https://my.carbon.click/transaction/2584d920-b125-4f38-af7b-3da1b3dd784a" target="_blank" className="w-240px btn btn-secondary">Trace Our Impact</a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5">
                <div className="container px-5">
                   <div className="row">
                        <div className="col-3">
                            <img style={{top: "48px", right: "-84px"}} className="z-2 mobile-hide h-400px position-absolute shadow-lg" src={kind_3} />
                        </div>
                        <div className="col-md-9">
                            <div className="bg-secondary text-left p-5 color-tertiary">
                                <div className="mobile-hide pl-5 py-5">
                                    <h1>Our Sustainability Journey</h1>
                                    <p>To help reduce the footprint of our KIND collection on the planet, we have partnered with CarbonClick to help restore and protect New Zealand forests. CarbonClick is a New Zealand founded and run company, offering businesses opportunities to reduce their carbon emissions through offsetting projects. Through our partnership with CarbonClick, we will be donating $10 from every pair of KIND collection shoes sold towards the Kaikoura project, helping to conserve and replant 99 hectares of lush native forest, helping to increase biodiversity and drawing down carbon.</p>
                                </div>
                                <div className="mobile-show text-left">
                                <img style={{top: "48px", right: "-84px"}} className="mb-3 w-100" src={kind_3} />
                                    <h3>Our Sustainability Journey</h3>
                                    <p>To help reduce the footprint of our KIND collection on the planet, we have partnered with CarbonClick to help restore and protect New Zealand forests. CarbonClick is a New Zealand founded and run company, offering businesses opportunities to reduce their carbon emissions through offsetting projects. Through our partnership with CarbonClick, we will be donating $10 from every pair of KIND collection shoes sold towards the Kaikoura project, helping to conserve and replant 99 hectares of lush native forest, helping to increase biodiversity and drawing down carbon.</p>
                                </div>
                            </div>
                        </div>
                   </div>
                </div>
            </section>

            <section className="py-5">
                <div className="container px-5">
                   <div className="row">
                        <div className="col-md-8">
                            <div className="bg-secondary text-right p-5 color-tertiary">
                                <div className="mobile-hide pr-5 py-5">
                                    <h1>About Kathryn Wilson</h1>
                                    <p>Kathryn Wilson has established herself as New Zealand's premier footwear designer,  becoming an influential business woman with a brand that is in constantly high demand. After graduating from Massey University and winning an AMP Scholarship in 2002, Kathryn honed her design skills and set about creating her own line of footwear. Stocked in over 100 local boutiques and with an ever-growing online market, the label is on the front foot in the fashion industry. Kathryn Wilson footwear takes its ethical and social responsibilities of our suppliers, our clients and the environment seriously. We are committed to upholding enjoyable and fair working conditions as a wholesaler, retailer and employer and ensure that our supply chain adheres to our legal, moral and ethical standards.</p>
                                </div>
                                <div className="mobile-show text-left">
                                <img style={{top: "48px", left: "-84px"}} className="mb-3 w-100" src={kw_profile} />
                                    <h3>About Kathryn Wilson</h3>
                                    <p>Kathryn Wilson has established herself as New Zealand's premier footwear designer,  becoming an influential business woman with a brand that is in constantly high demand. After graduating from Massey University and winning an AMP Scholarship in 2002, Kathryn honed her design skills and set about creating her own line of footwear. Stocked in over 100 local boutiques and with an ever-growing online market, the label is on the front foot in the fashion industry. Kathryn Wilson footwear takes its ethical and social responsibilities of our suppliers, our clients and the environment seriously. We are committed to upholding enjoyable and fair working conditions as a wholesaler, retailer and employer and ensure that our supply chain adheres to our legal, moral and ethical standards.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <img style={{top: "48px", left: "-84px"}} className="mobile-hide h-400px position-absolute shadow-lg" src={kw_profile} />
                        </div>
                   </div>
                </div>
            </section>


            <section className="py-5">
                <div className="container px-5">
                   <div className="row">
                        <div className="col-md-7">
                            <div className="bg-secondary text-right p-5 color-tertiary">
                                <div className="mobile-hide pr-5 py-5">
                                    <h1>Restoring New Zealand native forest</h1>
                                    <h4>Kaikoura, New Zealand</h4>
                                    <p>This project enables the conservation and reforrestation of 99 hectares of lush native forest, increasing biodiversity and drawing down carbon.</p>
                                    <a className="color-primary font-bold" target="_blank" href="https://my.carbon.click/projects/WAIKENE_FOREST_NZ">Learn more</a>
                                </div>
                                <div className="mobile-show text-left">
                                <img style={{top: "48px", left: "-84px"}} className="mb-3 w-100" src={`https://res.cloudinary.com/carbonclick/image/upload/v1618960669/Enterprise/Kathryn%20Wilson/img-4_mw7gig.png`} />
                                    <h3>Restoring New Zealand native forest</h3>
                                    <h4>Kaikoura, New Zealand</h4>
                                    <p>This project enables the conservation and reforrestation of 99 hectares of lush native forest, increasing biodiversity and drawing down carbon.</p>
                                    <a className="color-primary font-bold" target="_blank" href="https://my.carbon.click/projects/WAIKENE_FOREST_NZ">Learn more</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-5">
                            <img style={{top: "48px", left: "-84px"}} className="mobile-hide h-400px position-absolute shadow-lg" src={`https://res.cloudinary.com/carbonclick/image/upload/v1618960669/Enterprise/Kathryn%20Wilson/img-4_mw7gig.png`} />
                        </div>
                   </div>
                </div>
            </section>



            <section className="bg-secondary py-5 color-tertiary">
                <div className="container">
                    <div className="center">
                        <h3 className="font-bold mt-0 mb-4">Feeling Inspired?</h3>
                        <p>Make a difference by offsetting your personal carbon emissions with CarbonClick</p>
                        <div className="">
                            <a href={`https://my.carbon.click/${getMerchantCodeWithPrefix(merchantCode)}/subscribe`} target="_blank" className="btn btn-primary w-320px mb-3">Offset Your Personal Footprint</a>
                        </div>
                    </div>
                </div>
            </section>

            <div className="py-6">
                <div className="container text-center">
                    <h3 className="font-bold mb-4">Climate Friendly FAQs</h3>
                    <div className="mb-3 center text-left mw-800px">
                        <Accordian title={"What is a carbon offset?"} >A carbon credit is what is bought and sold when dealing with voluntary carbon offsets. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) or the Emissions Trading Register (New Zealand).</Accordian>
                        <Accordian title={"What does carbon offsetting do?"} >Carbon offsetting is a tool that allows individuals or companies to reduce their environmental impact. Purchasing carbon offsets supports environmental projects that remove greenhouse gases from the air, these projects could be things like reforestation projects or investment into renewable energy. Purchasing one carbon offset credit removes the equivalent of one tonne of CO2 from the atmosphere.</Accordian>
                        <Accordian title={"Who are CarbonClick?"} >CarbonClick is a New Zealand company that exists to reverse climate change, CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective. Building a happier and more sustainable future for everyone.</Accordian>
                        <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
                        <Accordian title={"How do I know the offset is trustworthy?"} >CarbonClick is committed to making carbon offsetting safe and trustworthy, we do this by tracing every transaction to the projects it supported so you can see the retirement certificates for every kg of CO2 offset. The trace link is sent in every purchase confirmation email, and can also be found on our website.</Accordian>
                    </div>
                </div>
            </div>



           
            {/*<div className="bg-green-light py-6">
                <div className="container text-center">
                    <div className="mb-5 center mw-600px">
                        <h2 className="font-light">Make a difference in fighting climate change</h2>
                        <p>Purchase a subscription to make an ongoing, traceable difference. We&apos;ll show you how your positive impacts grow each month.</p>
                    </div>

                    country && <PlansList
                        selectedPlan={selectedPlan}
                        onSelectedPlanChange={setSelectedPlan}
                        planChosen={planChosen}
                        country={country}
                        setLocationModalVisible={setShowModal}
                    />}
                </div>
            </div>*/}


            <div className="w-100 img-cover footer-img py-6 bg-white" >
                <div className="container color-dark py-5">
                    <p><b>Powered by</b></p>
                    <div className="d-flex">
                        <div>
                            <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                <img style={{ height: 30 }} className="footer-logo" src={logo_dark} alt="carbonclick" />
                            </a>
                        </div>
                        <div className="right">
                            <div>
                                <a href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row">
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-dark" href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">How it works</a></div>
                                <div className="mb-3"><a className="color-dark" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-dark" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                <div className="mb-3"><a className="color-dark" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-dark" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                                <div className="mb-3"><a className="color-dark" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default LandingPage;